import * as Styled from './StyleButtonBadge';

const IncompleteBadge = () => {
  return <Styled.Button>미답변</Styled.Button>;
};

export default IncompleteBadge;
